import React, { Fragment } from 'react'

import '../assets/stylesheets/styles.scss'

import Header   from './Header'
import Hero     from './Hero'
import Packages from './Packages'
import Location from './Location'
import Footer   from './Footer'

function App() {
  return (
    <Fragment>
      <div className="wrapper">
        <Header />
        <Hero />
        <Packages />
        <Location />
        <Footer />
      </div>
    </Fragment>
  );
}

export default App
